import { useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  ["Platform", "platform"],
  ["How it works", "how-it-works"],
  ["Performance", "performance"],
  ["Marketplace", "marketplace"],
  ["Team", "team"],
  ["FAQ", "faq"],
];

export const Logo = () => (
  <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
    <svg viewBox="0 0 32 32" className="h-8 w-8 shrink-0" aria-label="Trading Nifty logo">
      <rect x="1" y="1" width="30" height="30" rx="9" fill="#111823" stroke="#1f2937" strokeWidth="1.5" />
      <path d="M7 22.5 L12.5 16 L17.5 19.5 L25 9.5" stroke="#a3e635" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="25" cy="9.5" r="3" fill="#22d3ee" />
    </svg>
    <span className="font-display font-semibold text-[17px]">
      Trading <span className="text-[var(--tn-cyan)]">Nifty</span>
    </span>
  </a>
);

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[rgba(6,9,14,0.82)] backdrop-blur-xl border-b border-[var(--tn-line)]">
      <div className="max-w-[1152px] mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map(([label, id]) => (
            <a key={id} href={`#${id}`} data-testid={`nav-link-${id}`}
              className="text-sm text-[var(--tn-muted)] hover:text-[var(--tn-text)] transition-colors">
              {label}
            </a>
          ))}
          <a href="#waitlist" data-testid="nav-join-waitlist-btn" className="tn-btn">Join the waitlist</a>
        </nav>
        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[var(--tn-line)] px-5 py-4 flex flex-col gap-3 bg-[var(--tn-bg)]" data-testid="nav-mobile-menu">
          {LINKS.map(([label, id]) => (
            <a key={id} href={`#${id}`} onClick={() => setOpen(false)} className="text-[var(--tn-muted)] py-1">{label}</a>
          ))}
          <a href="#waitlist" onClick={() => setOpen(false)} className="tn-btn mt-2">Join the waitlist</a>
        </div>
      )}
    </header>
  );
};
